'use client';

import { useSyncExternalStore } from 'react';

// One shared one-second clock for every countdown on the page, instead of a
// timer per card. Returns null during server render and hydration, so time
// based text only appears once the page is live in the browser.

let now = Date.now();
const listeners = new Set();
let timer = null;

function subscribe(callback) {
  listeners.add(callback);
  if (!timer) {
    now = Date.now();
    timer = setInterval(() => {
      now = Date.now();
      listeners.forEach((fn) => fn());
    }, 1000);
  }
  return () => {
    listeners.delete(callback);
    if (listeners.size === 0) {
      clearInterval(timer);
      timer = null;
    }
  };
}

export function useNow() {
  return useSyncExternalStore(
    subscribe,
    () => now,
    () => null
  );
}

/** { days, hours, minutes, seconds, total } until `iso`, or null. */
export function timeLeft(iso, nowMs) {
  if (nowMs == null) return null;
  const total = Math.max(0, new Date(iso).getTime() - nowMs);
  const s = Math.floor(total / 1000);
  return {
    total,
    days: Math.floor(s / 86400),
    hours: Math.floor((s % 86400) / 3600),
    minutes: Math.floor((s % 3600) / 60),
    seconds: s % 60,
  };
}

export const pad = (n) => String(n).padStart(2, '0');
